export const orgSizes = ['0-10', '10-50', '50-100', '100-200', '200+'];
export const orgSizeOptions = orgSizes.map((item) => ({
  label: item,
  value: item,
}));
